import React, { useEffect, useState } from 'react';
import i18n from '../i18n';

interface I18nProviderProps {
  children: React.ReactNode;
}

export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkI18nReady = () => {
      if (i18n.isInitialized) {
        setIsReady(true);
      } else {
        // Wait for i18n to initialize
        i18n.on('initialized', () => {
          setIsReady(true);
        });
      }
    };

    checkI18nReady();

    return () => {
      i18n.off('initialized');
    };
  }, []);

  if (!isReady) {
    return (
      <div className="min-h-screen bg-ghost-50 flex items-center justify-center">
        <div className="text-ghost-400 text-sm">Loading...</div>
      </div>
    );
  }

  return <>{children}</>;
};